import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: "[dialogInsertion]",
})
export class CustomDialogDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
